import { createFileRoute } from '@tanstack/react-router'
import { BookingFlow } from '@/features/book-time'
import { BrandLogo } from '@/shared/ui/brand'

// Публичная страница гостя: без AppShell и без сессии — только бренд-шапка
// и сценарий брони по секретной ссылке.
export const Route = createFileRoute('/booking/$token')({
  component: BookingPage,
})

function BookingPage() {
  const { token } = Route.useParams()
  return (
    <main className="flex h-dvh flex-col">
      <header className="flex h-14 shrink-0 items-center gap-3 border-b px-gutter pt-safe">
        <BrandLogo className="h-6" />
        <span className="label">Бронирование времени</span>
      </header>
      <div className="min-h-0 flex-1 overflow-y-auto overscroll-contain px-gutter py-6 pb-safe-8">
        <BookingFlow token={token} />
      </div>
    </main>
  )
}
